"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZIPCODE_CHAR_LIMIT = exports.GUEST_ACCOUNTS = exports.withTranslation = exports.FLEXSHIP = exports.dot = exports.emDash = exports.MAX_FIELD_LENGTHS = exports.CONSTANTS = void 0;
/**-
 * CONSTANTS - general application wide   labels used
 */

exports.CONSTANTS = {
  en: {
    ALPHABET_ERROR: "Only alphabetical characters allowed",
    EMAIL_INVALID: "Invalid email address",
    REQUIRED_FIELD: "Required",
    PHONE_INVALID: "Invalid phone number",
    PATTERN_INVALID: "Invalid characters entered.",
    AUTH_ERROR: "Incorrect email/username or password",
    ERP_RESTRICTED_CHARACTERS: "The following special characters are not supported < > & ' \u201D",
    CONTACT_US: "contact us ",
    LOCKOUT_LABEL1: "Your user account has been locked due to too many invalid login attempts. Please",
    LOCKOUT_LABEL2: "for assistance.",
    FORGOT_PASSWORD: "Forgot password",
    RESET_PASSWORD: "reset your password",
    RESET_MESSAGE: "Your password needs to be reset. Please",
    RESET_MESSAGE2: "now.",
    LOG_IN: "Log In"
  },
  fr: {
    ALPHABET_ERROR: "Seuls les caractères alphabétiques sont autorisés",
    EMAIL_INVALID: "Adresse e-mail invalide",
    REQUIRED_FIELD: "Obligatoire",
    PHONE_INVALID: "Numéro de téléphone invalide",
    PATTERN_INVALID: "Caractères invalides saisis.",
    AUTH_ERROR: "E-mail/nom d'utilisateur ou mot de passe incorrect",
    ERP_RESTRICTED_CHARACTERS: "Les caract\xE8res sp\xE9ciaux suivants ne sont pas pris en charge < > & ' \u201D",
    CONTACT_US: "Nous contacter ",
    LOCKOUT_LABEL1: "Votre compte utilisateur a été verrouillé en raison d'un trop grand nombre de tentatives de connexion non valides. S'il vous plaît",
    LOCKOUT_LABEL2: "\xE0 l'aide.",
    FORGOT_PASSWORD: "Mot de passe oublié",
    RESET_PASSWORD: "Réinitialiser le mot de passe",
    RESET_MESSAGE: "votre mot de passe doit être réinitialisé.",
    RESET_MESSAGE2: "maintenant",
    LOG_IN: "Connexion"
  },
  es: {
    ALPHABET_ERROR: "Solo se permiten caracteres alfabéticos",
    EMAIL_INVALID: "Dirección de correo electrónico inválida",
    REQUIRED_FIELD: "Requerido",
    PHONE_INVALID: "Numero de telefono invalido",
    PATTERN_INVALID: "Se ingresaron caracteres no válidos.",
    AUTH_ERROR: "Correo electrónico / nombre de usuario o contraseña incorrectos",
    ERP_RESTRICTED_CHARACTERS: "Los siguientes caracteres especiales no son compatibles < > & ' \u201D",
    CONTACT_US: "Contacta con nosotras ",
    LOCKOUT_LABEL1: "Su cuenta de usuario ha sido bloqueada debido a demasiados intentos de inicio de sesión no válidos. Por favor",
    LOCKOUT_LABEL2: "para asistencia.",
    FORGOT_PASSWORD: "Se te olvidó tu contraseña",
    RESET_PASSWORD: "restablecer su contraseña",
    RESET_MESSAGE: "Es necesario restablecer su contraseña. Por favor",
    RESET_MESSAGE2: "ahora.",
    LOG_IN: "Iniciar sesión"
  }
};
exports.MAX_FIELD_LENGTHS = {
  HEADER_PO: 15,
  LINE_LEVEL_PO: 15,
  LINE_LEVEL_NOTES: 35,
  CUSTOMER_REFERENCE: 12
};
exports.emDash = "\u2014";
exports.dot = "\xB7";
exports.FLEXSHIP = "FL3XSH1P";
/**
 * @describe WithLanguage - Language lables for Header/Footer
 */

exports.withTranslation = {
  us: {
    en: "United States",
    fr: "États Unis",
    es: "Estados Unidos"
  },
  ca: {
    en: "Canada",
    fr: "Canada",
    es: "Canadá"
  },
  mx: {
    en: "Mexico",
    fr: "Mexique",
    es: "México"
  },
  cn: {
    en: "China",
    fr: "Chine",
    es: "Porcelana"
  },
  en: {
    en: "English",
    fr: "Anglaise",
    es: "Inglesa"
  },
  es: {
    en: "Spanish",
    fr: "Espanol",
    es: "Española"
  },
  fr: {
    en: "French",
    fr: "Français",
    es: "Francesa"
  },
  shoppinglist: {
    en: "Shopping List",
    fr: "Liste de \ncourses",
    es: "Lista de \nla compra"
  },
  searchPlaceHolder: {
    en: "Search part#, keyword, page...",
    es: "Número de parte de búsqueda, palabra clave, página...",
    fr: "Rechercher un numéro de pièce, un mot clé, une page..."
  },
  myAccount: {
    en: "My Account",
    es: "Mi cuenta",
    fr: "Mon compte"
  },
  login: {
    en: "Log In",
    es: "Acceso",
    fr: "Connexion"
  },
  username: {
    en: "Email or Username",
    es: "Email or Username",
    fr: "Email or Username"
  },
  password: {
    en: "Password",
    es: "Password",
    fr: "Password"
  },
  show: {
    en: "SHOW",
    es: "REVELAR",
    fr: "RÉVÉLER"
  },
  hide: {
    en: "HIDE",
    es: "ESCONDER",
    fr: "CACHER"
  },
  cart: {
    en: "Cart",
    es: "Carro",
    fr: "Chariot"
  },
  signUp: {
    en: "Sign up",
    fr: "S'inscrire",
    es: "Inscribirse"
  },
  allLocations: {
    en: "All Locations",
    fr: "Tous les emplacements",
    es: "Todas las localizaciones"
  },
  allRightsReserved: {
    en: "All Rights Reserved.",
    fr: "Tous les droits sont réservés.",
    es: "Reservados todos los derechos."
  },
  getStocklist: {
    en: "Get Stock List",
    fr: "Liste  \nde Stocks",
    es: "Lista de \nExistencias"
  },
  creditApplication: {
    en: "Credit Application",
    fr: "Demande de crédit",
    es: "Solicitud de crédito"
  },
  contactUs: {
    en: "Contact Us",
    fr: "Communiquer \n Avec Nous",
    es: "Contáctenos"
  },
  shoppingLists: {
    en: "Shopping Lists",
    fr: "Listes de courses",
    es: "Listas de compras"
  },
  addShoppingList: {
    en: "+Add Shopping List",
    fr: "+Ajouter une liste de courses",
    es: "+Agregar lista de compras"
  },
  noListToDisplay: {
    en: "No list to display",
    fr: "Aucune liste à afficher",
    es: "No hay lista para mostrar"
  },
  searchShoppingList: {
    en: "Search across shopping list",
    fr: "Rechercher dans la liste de courses",
    es: "Buscar en la lista de compras"
  },
  mostRecent: {
    en: "Most Recent",
    fr: "Le plus récent",
    es: "Más reciente"
  },
  sharedWithMe: {
    en: "Shared with me",
    fr: "Partagé avec moi",
    es: "Comparte conmigo"
  },
  personal: {
    en: "Personal",
    fr: "Personnel",
    es: "Personal"
  },
  viewMore: {
    en: "View More",
    fr: "Voir plus",
    es: "Ver más"
  },
  loading: {
    en: "Loading...",
    fr: "Chargement...",
    es: "Cargando..."
  },
  noRecordFound: {
    en: "No Record Found",
    fr: "Aucun Enregistrement Trouvé",
    es: "ningún record fue encontrado"
  },
  error: {
    en: "There was a problem",
    fr: "Il y avait un problème",
    es: "Había un problema"
  },
  createListTitle: {
    en: "Create a new list",
    fr: "Créer une nouvelle liste",
    es: "Créer une nouvelle liste"
  },
  switchAccounts: {
    en: "Switch Accounts",
    fr: "Changer de compte",
    es: "Cambiar cuentas"
  },
  featureSaveProductText: {
    en: "Lists will only be visible and editable to you upon creation. Go to Shopping Lists to share with users across your company.",
    fr: "Les listes ne seront visibles et modifiables que lors de leur création. Accédez aux listes de courses pour les partager avec les utilisateurs de votre entreprise.",
    es: "Las listas solo serán visibles y editables para usted al momento de su creación. Vaya a Listas de compras para compartir con usuarios de su empresa."
  },
  saveProductText: {
    en: "Use shopping lists to save products for later.",
    fr: "Utilisez les listes de courses pour enregistrer les produits pour plus tard.",
    es: "Use listas de compras para guardar productos para más adelante."
  },
  allListText: {
    en: "Lists will be visible and editable to users across your company.",
    fr: "Les listes seront visibles et modifiables par les utilisateurs de votre entreprise.",
    es: "Las listas serán visibles y editables para los usuarios de su empresa."
  },
  listName: {
    en: "List Name",
    fr: "Liste de noms",
    es: "Lista de nombres"
  },
  learnMore: {
    en: "Learn more",
    fr: "Apprendre encore plus",
    es: "Aprende más"
  },
  createList: {
    en: "Create List",
    fr: "Créer une liste",
    es: "Crear lista"
  },
  locations: {
    en: "Locations",
    fr: "Emplacements",
    es: "Ubicaciones"
  },
  followUs: {
    en: "Follow Us",
    fr: "Suivez nous",
    es: "Síganos"
  },
  allMetalSolutions: {
    en: "All Metal Solutions",
    fr: "Toutes les \n solutions métalliques",
    es: "Todas las \n  soluciones de metal"
  },
  allMetalResources: {
    en: "All Metal Resources",
    fr: "Toutes les \n ressources métalliques",
    es: "Todas las \n  recursos metálicos"
  },
  whyRyerson: {
    en: "Why Ryerson",
    fr: "Pourquoi Ryerson",
    es: "Por qué Ryerson"
  },
  usStatePrivacyDisclosure: {
    en: "U.S. State Privacy Disclosure (CA, CO, CT, and VA)",
    fr: "Divulgation de la confidentialité des États-Unis (CA, CO, CT et VA)",
    es: "Divulgación de privacidad del estado de EE. UU. (CA, CO, CT y VA)"
  },
  californiaTransparencySupplyChainAct: {
    en: "California Transparency in Supply Chains Act",
    fr: "Loi californienne sur la transparence des chaînes d'approvisionnement",
    es: "Ley de Transparencia en las Cadenas de Suministro de California"
  },
  securityStatement: {
    en: "Security Statement",
    fr: "Déclaration de sécurité",
    es: "Declaración de seguridad"
  },
  termsAndConditions: {
    en: "Terms & Conditions",
    fr: "termes et conditions",
    es: "Términos y condiciones"
  },
  privacyPolicy: {
    en: "Privacy Policy",
    fr: "Politique de confidentialité",
    es: "Política de privacidad"
  },
  transparencyInCoverage: {
    en: "Transparency in Coverage",
    fr: "Transparence dans la couverture",
    es: "Transparencia en la Cobertura"
  },
  liveChat: {
    en: "Live Chat",
    fr: "Chat en direct",
    es: "Chat en vivo"
  },
  scanBarcode: {
    en: "Scan Barcode",
    fr: "Scanner le code-barres",
    es: "Escanear código de barras"
  },
  barcodeInstructions: {
    en: "Center barcode on screen to look up item and access inventory, price and delivery.",
    fr: "Centrez le code-barres sur l'écran pour rechercher l'article et accéder à l'inventaire, au prix et à la livraison.",
    es: "Centre el código de barras en la pantalla para buscar el artículo y acceder al inventario, el precio y la entrega."
  },
  cameraPermissionError: {
    en: "Camera Permission Not Allowed",
    fr: "Autorisation de la caméra non autorisée",
    es: "Permiso de cámara no permitido"
  },
  cancel: {
    en: "Cancel",
    fr: "Annuler",
    es: "Cancelar"
  },
  search: {
    en: "Search",
    es: "Rechercher",
    fr: "Buscar"
  },
  metalFinder: {
    en: "Metal Finder",
    es: "Recherche de métaux",
    fr: "Buscador de metales"
  },
  customerPortal: {
    en: "Customer Portal",
    es: "Portal del Cliente",
    fr: "Portail Clients"
  }
}; //Array of guest user accounts

exports.GUEST_ACCOUNTS = ["99"];
exports.ZIPCODE_CHAR_LIMIT = {
  us: 10,
  ca: 7,
  mx: 5
};